import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
function fill(text, tokens) {
    return text.replace(/\{(\w+)\}/g, (_, k) => tokens[k] ?? `{${k}}`);
}
export const SolutionBlockCard = ({ block, tokens }) => {
    return (_jsx(Box, { sx: {
            p: { xs: 5, md: 6 },
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'background.paper',
        }, children: _jsxs(Stack, { direction: "row", spacing: 3, alignItems: "flex-start", children: [_jsx(CheckCircleIcon, { sx: { color: 'success.main', mt: 0.5 } }), _jsxs(Stack, { spacing: 2, children: [_jsx(Typography, { variant: "overline", sx: { color: 'primary.main', fontWeight: 600, letterSpacing: 0.5 }, children: block.eyebrow }), _jsx(Typography, { variant: "h6", sx: { fontWeight: 700 }, children: fill(block.title, tokens) }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: fill(block.body, tokens) })] })] }) }));
};
